function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
import BaseTemplate from "components/templates/base-template";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component";
import PictureComponent from "/components/core/picture/picture-component";
import Slider from "react-slick";
import { parseSocialDescription } from "/server/services/comeet-service/comeet-parsing-service.js";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { MAIN_ID } from "constants/element-ids";
import PlainBannerComponent from "segments/desktop/banner/layouts/plain-banner/plain-banner-component";
import { WORKOS_IRIS_THEME_ID } from "segments/segments-service";
import classnames from "classnames";
import FlashLight from "static/svg/light.svg";
// SVGS:
import SVGQuote from "/static/svg/careers/quote.svg";
import SVGFilterOff from "/static/svg/careers/filterOff.svg";
import SVGFilterOn from "/static/svg/careers/filterOn.svg";
import SVGFilterOnCircle from "/static/svg/careers/filterOnCircle.svg";
import SVGSearch from "/static/svg/careers/search.svg";
import SVGSearchAlt from "/static/svg/careers/search-alt.svg";
import SVGClear from "/static/svg/careers/icon-clear.svg";
import DownArrow from "/static/svg/arrow-down.svg";
import DownPointedArrow from "/static/svg/careers/arrow2.svg";
import SVGCaret from "/static/svg/careers/small-caret.svg";
import SVGCloseX from "/static/svg/careers/closeX.svg";
import SVGBackArrow from "/static/svg/careers/back-arrow.svg";
import { isMobile } from "is-mobile";
import { CAREER_PAGE_CLICK, CAREER_KIND_SEARCH_FIELD_START_TYPING, CAREER_KIND_SEARCH_FIELD_SUBMITTED, CAREER_KIND_LOCATION_FILTER_CHOSEN, CAREER_KIND_TEAM_FILTER_CHOSEN, CAREER_KIND_FILTER_BY_LOCATION, CAREER_KIND_FILTER_BY_TEAM, CAREER_KIND_SHOW_MORE_OPTIONS, CAREER_KIND_DIDNT_FIND_POSITION, CAREER_KIND_SPECIFIC_POSITION_CLICKED, CAREER_KIND_NEWS_ITEM_CLICKED, CAREER_KIND_IMAGES_HOVERED, CAREER_KIND_SEARCH_OPEN_POSITION_BOTTOM_CTA } from "/constants/bigbrain-event-types";
import YoutubeVideoComponent from "components/core/youtube-video/youtube-video-component";
import { ISRAEL_ISO2 } from "services/countries/countries-service";
import { getDeptIDFromPosition, getDeptInfo, getLocationID, getLocationInfoFromPosition, getLocationIDFromPosition } from "./careers-service.js";
import TextAndProof from "./careers-hero-component/careers-text-and-proof-component";
import ScrollTopFabComponent from "./scroll-top-fab/scroll-top-fab-component";
import careersConfig from "./careers-config.json";
import CareersHeroComponent from "./careers-hero-component/careers-hero-component";
import { DESCRIPTION, META_OVERRIDE, TITLE, POSITION_TYPE_INTERNAL, INTERNAL_JOBS_TITLE, INTERNAL_JOBS_DESCRIPTION, CAREERS_ROOT_URL, INTERNAL_CAREERS_ROOT_URL, SEARCH_DEBOUNCE_RATE } from "./careers-constants.js";
import { StyledCareersComponent } from "./careers-component.scss";
// how many rows to show initally:
const COLLPASED_TABLE_RESULTS_LIMIT = 7;
const COLLPASED_TABLE_RESULTS_LIMIT_MOBILE = 3;
// how many rows to show in full page:
const TABLE_RESULTS_PAGE_SIZE = 10;
const LOCATION_URL_PARAM = "location";
const DEPARTMENT_URL_PARAM = "department";
const SEARCH_TERM_URL_PARAM = "search";
const bestPlaceToWorkProps = {
    text: "It’s official: monday.com is a certified great place to work",
    image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/careers_site/badges.png",
        alt: "best place to work badges"
    }
};
class CareersComponent extends PureComponent {
    componentDidMount() {
        var _careersConfig_testimonials;
        var _this = this;
        this.setPositionTableData().then(function() {
            var _ref = _async_to_generator(function*(data) {
                yield _this.setState({
                    positionsTableData: data
                });
                _this.refreshFilteredTeams();
                _this.refreshFilteredResults();
                _this.refreshPositionCounts();
            });
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }());
        const urlParams = new URLSearchParams(window.location.search);
        const selectedLocationId = urlParams.get(LOCATION_URL_PARAM);
        const selectedDeptId = urlParams.get(DEPARTMENT_URL_PARAM);
        const searchTerm = urlParams.get(SEARCH_TERM_URL_PARAM);
        let selectedLocation, selectedDept;
        if (selectedLocationId) {
            selectedLocation = careersConfig.locations.find((loc)=>loc.id === selectedLocationId);
        }
        if (selectedDeptId) {
            selectedDept = careersConfig.departments.find((dept)=>dept.id === selectedDeptId);
        }
        if (searchTerm) {
            this.performSearch();
            this.setState({
                searchTerm,
                searchTermInput: searchTerm
            });
        }
        // for mobile - we show only "featured" testimonials:
        this.setState({
            selectedLocation,
            selectedDept,
            testimonials: !isMobile() ? careersConfig.testimonials : (_careersConfig_testimonials = careersConfig.testimonials) === null || _careersConfig_testimonials === void 0 ? void 0 : _careersConfig_testimonials.filter((t)=>t.featuredInMobile)
        });
    }
    setPositionTableData() {
        var _this = this;
        return _async_to_generator(function*() {
            // this methods puts ALL positions in memory. filtering is done in the refreshFilteredResults method.
            // this method will re-order comeet's positions so that first "page" will include a random job from each location
            // raw positions data from comeet - before re-ordering to table display:
            let data = _this.props.positionsData;
            // FILTER:
            data = data.filter((position)=>{
                // filter all positions marked with "unlisted":
                // filter all positions with invalid team / locations:
                let ret = false;
                if (position && position.department && position.department.toLowerCase() != "unlisted") {
                    const locID = position && position.location ? getLocationID(position.location.name) : null;
                    const teamID = getDeptIDFromPosition(position);
                    if (!locID) console.warn("Filtering position with bad locationID", locID, position);
                    if (!teamID) console.warn("Filtering position with bad teamID", teamID, position);
                    ret = locID && teamID;
                }
                return ret;
            });
            // SORT:
            data.sort((a, b)=>a.name > b.name ? 1 : -1);
            // helper method: returns idx of a random job from a location (e.g a random Tel Aviv job):
            const findRandomLocationPosition = (city, notThisUID = "---z---")=>{
                const matches = data.filter((pos)=>pos.uid !== notThisUID && pos.location && pos.location.city && pos.location.city.toLowerCase().indexOf(city) >= 0);
                const rndIdx = Math.floor(Math.random() * matches.length);
                const randomElement = matches[rndIdx];
                return data.indexOf(randomElement);
            };
            // helper method to re-position array elements
            const moveInArray = (arr, from, to)=>{
                arr.splice(to, 0, arr.splice(from, 1)[0]);
            };
            // tel aviv needs 2 entries, so making sure not randoming same one again:
            const ta1idx = findRandomLocationPosition("aviv");
            moveInArray(data, ta1idx, 0);
            if (ta1idx > -1) {
                const ta1uid = data[ta1idx].uid;
                moveInArray(data, findRandomLocationPosition("aviv", ta1uid), 1);
            }
            moveInArray(data, findRandomLocationPosition("york"), 2);
            moveInArray(data, findRandomLocationPosition("sf"), 3);
            moveInArray(data, findRandomLocationPosition("london"), 4);
            moveInArray(data, findRandomLocationPosition("miami"), 5);
            return data;
        })();
    }
    handleTeamsDropdownButtonKeyPress(event) {
        if (event.key === "Enter") {
            const { isTeamsDropdownOpen } = this.state;
            this.setState({
                isTeamsDropdownOpen: !isTeamsDropdownOpen
            });
        }
        event.preventDefault();
        return false;
    }
    handleLocationsDropdownButtonKeyPress(event) {
        if (event.key === "Enter") {
            const { isLocationDropdownOpen } = this.state;
            this.setState({
                isLocationDropdownOpen: !isLocationDropdownOpen
            });
        }
    }
    handleShowMoreClick(e) {
        const { isShowMore } = this.state;
        this.setState({
            isShowMore: !isShowMore
        });
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_SHOW_MORE_OPTIONS,
            info1: isShowMore
        });
        this.scrollToPositions();
    }
    handleClearSearchClick(e) {
        var _this = this;
        return _async_to_generator(function*() {
            const { currentMobileSideMenu } = _this.state;
            if (currentMobileSideMenu == "locations") yield _this.setState({
                selectedLocation: null
            });
            else if (currentMobileSideMenu == "teams") yield _this.setState({
                selectedDept: null
            });
            else yield _this.setState({
                selectedLocation: null,
                selectedDept: null
            });
            _this.refreshFilteredResults();
            _this.refreshFilteredTeams();
        })();
    }
    handleClearSearchTermClick(e) {
        var _this = this;
        return _async_to_generator(function*() {
            yield _this.setState({
                searchTermInput: ""
            });
            const { searchTerm } = _this.state;
            if (searchTerm != "") _this.performSearch();
            _this.searchTermTextbox.focus();
        })();
    }
    handleMobileSideMenuToggle(e) {
        const { isMobileSideMenuOpen } = this.state;
        this.setState({
            isMobileSideMenuOpen: !isMobileSideMenuOpen,
            currentMobileSideMenu: "main"
        });
    }
    reportSearchFieldTouchedEvent() {
        const { searchTermIsDirty, searchTermInput } = this.state;
        if (!searchTermIsDirty) {
            BigBrain("track", CAREER_PAGE_CLICK, {
                kind: CAREER_KIND_SEARCH_FIELD_START_TYPING,
                info1: searchTermInput,
                placement: this.pageLoadUniqueId
            });
        }
        this.setState({
            searchTermIsDirty: true
        });
    }
    handleSearchTermInputChange(e) {
        var _this = this;
        return _async_to_generator(function*() {
            clearTimeout(_this.debounceTimeout);
            _this.setState({
                searchTermInput: e.target.value
            });
            _this.reportSearchFieldTouchedEvent();
            _this.debounceTimeout = setTimeout(()=>{
                _this.performSearch();
            }, SEARCH_DEBOUNCE_RATE);
        })();
    }
    handleSearchTermInputChangeForMobile(e) {
        var _this = this;
        return _async_to_generator(function*() {
            yield _this.setState({
                searchTermInput: e.target.value
            });
            // this.performSearch();
            _this.reportSearchFieldTouchedEvent();
        })();
    }
    performSearch() {
        var _this = this;
        return _async_to_generator(function*() {
            const { searchTermInput } = _this.state;
            yield _this.setState({
                searchTerm: searchTermInput
            });
            _this.refreshFilteredResults();
            BigBrain("track", CAREER_PAGE_CLICK, {
                kind: CAREER_KIND_SEARCH_FIELD_SUBMITTED,
                info1: searchTermInput,
                placement: _this.pageLoadUniqueId
            });
            _this.updateUrlParams();
        })();
    }
    onPositionLinkClicked(posName, location, department) {
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_SPECIFIC_POSITION_CLICKED,
            info1: posName,
            info2: location === null || location === void 0 ? void 0 : location.name,
            info3: department === null || department === void 0 ? void 0 : department.name,
            placement: this.pageLoadUniqueId
        });
        return true;
    }
    onNewsItemClicked(newsUrl) {
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_NEWS_ITEM_CLICKED,
            info1: newsUrl,
            placement: this.pageLoadUniqueId
        });
        return true;
    }
    handleDropdownOptionKeyPress(event, onChangeFunc) {
        if (event.key === "Enter") {
            onChangeFunc();
        }
    }
    updateUrlParams() {
        const { selectedLocation, selectedDept, searchTerm } = this.state;
        window.history.pushState({}, "", window.location.href);
        const params = new URLSearchParams(window.location.search);
        selectedLocation ? params.set(LOCATION_URL_PARAM, selectedLocation.id) : params.delete(LOCATION_URL_PARAM);
        selectedDept ? params.set(DEPARTMENT_URL_PARAM, selectedDept.id) : params.delete(DEPARTMENT_URL_PARAM);
        searchTerm ? params.set(SEARCH_TERM_URL_PARAM, searchTerm) : params.delete(SEARCH_TERM_URL_PARAM);
        window.history.pushState({}, "", `?${params.toString()}`);
    }
    onLocationChange(newSelectedLocation) {
        var _this = this;
        return _async_to_generator(function*() {
            // clicking same value twice de-selects the filter:
            const { selectedLocation } = _this.state;
            const newValue = selectedLocation && newSelectedLocation.id === selectedLocation.id ? null : newSelectedLocation;
            yield _this.setState({
                selectedLocation: newValue,
                selectedDept: null
            });
            _this.forceBulmaDropdownsToClose();
            _this.refreshFilteredResults();
            _this.refreshFilteredTeams();
            _this.setState({
                isLocationDropdownOpen: false
            });
            if (newValue) {
                // after selecting a location in the team dropdown - we open the next dropdown.
                // desktop: it will stay forced open until click anywhere else, or hover on the "location" dropdown
                _this.setState({
                    isTeamsDropdownOpen: true
                });
                // mobile:
                _this.setState({
                    currentMobileSideMenu: "teams"
                });
            }
            BigBrain("track", CAREER_PAGE_CLICK, {
                kind: CAREER_KIND_LOCATION_FILTER_CHOSEN,
                info1: newSelectedLocation === null || newSelectedLocation === void 0 ? void 0 : newSelectedLocation.id,
                placement: _this.pageLoadUniqueId
            });
            _this.updateUrlParams();
        })();
    }
    resetTeamDropdownOpenState() {
        // after selecting a location in the team dropdown - we open the next dropdown. it will stay forced open until click anywhere else, or hover on the "location" dropdown
        this.setState({
            isTeamsDropdownOpen: false
        });
    }
    setMobileSideCurrentSubMenu(subMenuName) {
        this.setState({
            currentMobileSideMenu: subMenuName
        });
        if (subMenuName != "main") {
            BigBrain("track", CAREER_PAGE_CLICK, {
                kind: subMenuName === "teams" ? CAREER_KIND_FILTER_BY_TEAM : CAREER_KIND_FILTER_BY_LOCATION,
                placement: this.pageLoadUniqueId
            });
        }
    }
    getTeamSpriteCssClassName(deptInfo, teamPicSpriteIndexLastUsedPerTeam) {
        // team-pics-sprite-CS1
        // sprite file /static/img/careers/team_pics_sprite.png that is used at css class: .team-pics-sprite
        // created with https://spritegen.website-performance.org/
        // here we match a team object with a className to show the relevant team pic, making sure that images are not repeated twice in a row
        // returned class name example: team-pics-sprite-Consulting3
        if (deptInfo) {
            const lastIndexUsedForThisTeam = deptInfo.id in teamPicSpriteIndexLastUsedPerTeam ? teamPicSpriteIndexLastUsedPerTeam[deptInfo.id] : 0;
            let thisIndex = (lastIndexUsedForThisTeam + 1) % (deptInfo.teamPicsCount + 1);
            if (thisIndex == 0) thisIndex = 1;
            teamPicSpriteIndexLastUsedPerTeam[deptInfo.id] = thisIndex;
            return deptInfo.teamPicClassName + thisIndex;
        }
    }
    onDeptChange(newSelectedDept) {
        var _this = this;
        return _async_to_generator(function*() {
            // clicking same value twice de-selects the filter:
            const { selectedDept, isMobileSideMenuOpen } = _this.state;
            const newValue = selectedDept && newSelectedDept.id === selectedDept.id ? null : newSelectedDept;
            yield _this.setState({
                selectedDept: newValue
            });
            // after picking team - closing open filters:
            // desktop:
            _this.forceBulmaDropdownsToClose();
            // mobile:
            if (isMobileSideMenuOpen) _this.handleMobileSideMenuToggle();
            _this.refreshFilteredResults();
            BigBrain("track", CAREER_PAGE_CLICK, {
                kind: CAREER_KIND_TEAM_FILTER_CHOSEN,
                info1: newSelectedDept === null || newSelectedDept === void 0 ? void 0 : newSelectedDept.id,
                placement: _this.pageLoadUniqueId
            });
            _this.updateUrlParams();
        })();
    }
    forceBulmaDropdownsToClose() {
        var _this = this;
        return _async_to_generator(function*() {
            _this.setState({
                forceDropdownsToClose: true,
                isTeamsDropdownOpen: false
            });
            setTimeout(()=>{
                _this.setState({
                    forceDropdownsToClose: false
                });
            }, 100);
        })();
    }
    refreshFilteredResults() {
        const { positionsTableData, searchTerm, selectedDept, selectedLocation } = this.state;
        const term = searchTerm.toLowerCase();
        const searchTermTokens = searchTerm.trim().length == 0 ? [] : searchTerm.trim().split(" ");
        if (positionsTableData) {
            try {
                this.setState({
                    isLoaderShown: true
                });
                // FILTERING:
                const filteredData = positionsTableData.filter((pos)=>{
                    if (pos.department.toLowerCase() === "unlisted") {
                        return false;
                    }
                    // implied else:
                    const dept = getDeptInfo(pos);
                    const deptName = dept ? getDeptInfo(pos).name : "";
                    const location = getLocationInfoFromPosition(pos);
                    const locationName = location ? location.name : "";
                    // filtering by dept & location dropdown:
                    if (selectedDept && selectedDept.id != dept.id || selectedLocation && selectedLocation.id != location.id) {
                        return false;
                    }
                    // filtering by text search:
                    if (searchTermTokens.length == 0) return true;
                    // possible perf. improvement: pre-process this into positionsTableData
                    const positionDetails = pos.details && pos.details.map((elem)=>{
                        return elem.value;
                    }).join(" ");
                    const searchString = (pos.name + deptName + locationName + positionDetails).toLowerCase();
                    if (searchString.indexOf(term) >= 0) {
                        if (pos.name.toLowerCase().includes(term)) {
                            pos.displayOrder = 1;
                        } else if (deptName.toLowerCase().includes(term)) {
                            pos.displayOrder = 2;
                        } else {
                            pos.displayOrder = 99;
                        }
                        return true;
                    }
                });
                // SORT: sorting again if there are any filters - to re-shuffle the previously randomed position from each location on the first page
                const hasAnyFiltersOrSearch = selectedDept || selectedLocation || searchTerm && searchTerm.trim() != "";
                if (hasAnyFiltersOrSearch) {
                    filteredData.sort((a, b)=>a.displayOrder > b.displayOrder ? 1 : -1);
                }
                // MOCK LOAD:
                const MOCK_WAIT_TIME_MSEC = 550;
                setTimeout(()=>{
                    this.setState({
                        isLoaderShown: false,
                        filteredPositions: filteredData,
                        currentPageNum: 1
                    });
                }, MOCK_WAIT_TIME_MSEC);
                if (filteredData.length == 0) {
                    BigBrain("track", CAREER_PAGE_CLICK, {
                        kind: CAREER_KIND_DIDNT_FIND_POSITION,
                        placement: this.pageLoadUniqueId
                    });
                }
            } catch (ex) {
                console.error("refreshFilteredResults.err", ex);
                this.setState({
                    isLoaderShown: false
                });
            }
        }
    }
    getPositionsPage(pageIdx) {
        const { filteredPositions } = this.state;
        if (!filteredPositions) return [];
        return filteredPositions.slice((pageIdx - 1) * TABLE_RESULTS_PAGE_SIZE, pageIdx * TABLE_RESULTS_PAGE_SIZE);
    }
    setPageNumber(pageNum) {
        var _this = this;
        return _async_to_generator(function*() {
            yield _this.setState({
                isLoaderShown: true
            });
            // MOCK LOAD:
            const MOCK_WAIT_TIME_MSEC = 350;
            setTimeout(()=>{
                _this.setState({
                    isLoaderShown: false,
                    currentPageNum: pageNum
                });
                _this.scrollToPositions();
            }, MOCK_WAIT_TIME_MSEC);
        })();
    }
    refreshPositionCounts() {
        // count positions data: (do from filteredResults if requested)
        const { positionsTableData } = this.state;
        const locationsPositionCount = {};
        careersConfig.locations.map((loc)=>{
            locationsPositionCount[loc.id] = 0;
        });
        const teamPositionCount = {};
        careersConfig.departments.map((dept)=>{
            teamPositionCount[dept.id] = 0;
        });
        positionsTableData === null || positionsTableData === void 0 ? void 0 : positionsTableData.map((positionObj)=>{
            const locID = getLocationID(positionObj.location.name);
            const teamID = getDeptIDFromPosition(positionObj);
            locationsPositionCount[locID]++;
            teamPositionCount[teamID]++;
        });
        this.setState({
            locationsPositionCount,
            teamPositionCount
        });
    }
    scrollToPositions() {
        // scroll to results, adding fixed header height:
        const HEADER_HEIGHT = 72;
        const MOBILE_FIXED_HEIGHT = 130;
        const headerOffset = HEADER_HEIGHT + (isMobile() ? MOBILE_FIXED_HEIGHT : 0);
        const scrollTarget = document.querySelector(".section-positions").offsetTop;
        window.scrollTo({
            top: scrollTarget - headerOffset,
            left: 0,
            behavior: "smooth"
        });
    }
    getPositionShortSanitizedText(posObj) {
        if (!posObj || !posObj.details || posObj.details.length == 0) return;
        // sanitizing comeet text here:
        // const sanitized = parseSocialDescription(posObj.details[0]);
        const descriptionField = posObj.details.find((x)=>x.name == "Description");
        const sanitized = descriptionField ? parseSocialDescription(descriptionField) : "";
        const MAX_LENGTH = 150;
        const substr = sanitized.length <= MAX_LENGTH ? sanitized : sanitized.substring(0, MAX_LENGTH);
        return substr;
    }
    refreshFilteredTeams() {
        const { positionsTableData } = this.state;
        // department dropdown is filtered by the location dropdown:
        const { selectedLocation } = this.state;
        // fallback: all options
        let refreshedOptions = careersConfig.departments;
        if (selectedLocation) {
            refreshedOptions = [];
            for (const dept of careersConfig.departments){
                // for each dept, we search if it has any job in this location:
                const firstFound = positionsTableData.find((pos)=>selectedLocation.id == getLocationIDFromPosition(pos) && dept.id == getDeptIDFromPosition(pos));
                if (firstFound) refreshedOptions.push(dept);
            }
        }
        this.setState({
            departmentsDropOptions: refreshedOptions
        });
    }
    onBottomCTAClick() {
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_SEARCH_OPEN_POSITION_BOTTOM_CTA
        });
    }
    trackEventImageTileHover() {
        BigBrain("track", CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_IMAGES_HOVERED
        });
    }
    // count all distincts in array:
    countPositionLocations(positions) {
        if (positions) {
            const positionLocations = positions.map((pos)=>getLocationIDFromPosition(pos));
            return [
                ...new Set(positionLocations)
            ].length;
        }
    }
    countPositionTeams(positions) {
        if (positions) {
            const positionTeams = positions.map((pos)=>getDeptIDFromPosition(pos));
            return [
                ...new Set(positionTeams)
            ].length;
        }
    }
    getPaginationArray(c, m) {
        // https://gist.github.com/kottenator/9d936eb3e4e3c3e02598
        // returns an array of page numbers, and '...''s,
        // e.g. [1, "...", 8, 9, 10, 11, 12, "...", 20]
        const current = c, last = m, delta = isMobile() ? 1 : 2, left = current - delta, right = current + delta + 1, range = [], rangeWithDots = [];
        let l;
        for(let i = 1; i <= last; i++){
            if (i == 1 || i == last || i >= left && i < right) {
                range.push(i);
            }
        }
        for (const i of range){
            if (l) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i - l !== 1) {
                    rangeWithDots.push("...");
                }
            }
            rangeWithDots.push(i);
            l = i;
        }
        return rangeWithDots;
    }
    render() {
        const { selectedLocation, selectedDept, searchTermInput, forceDropdownsToClose, departmentsDropOptions, filteredPositions, isShowMore, locationsPositionCount, teamPositionCount, isTeamsDropdownOpen, isLocationDropdownOpen, isMobileSideMenuOpen, currentMobileSideMenu, currentPageNum, isLoaderShown } = this.state;
        const locationsDropOptions = careersConfig.locations;
        const numOfPages = !filteredPositions ? 1 : Math.ceil(filteredPositions.length / TABLE_RESULTS_PAGE_SIZE);
        const paginationArray = this.getPaginationArray(currentPageNum, numOfPages);
        const isInternalMobilityPage = this.isInternalMobilityPage();
        const ctaText = this.getCtaText();
        return /*#__PURE__*/ _jsxs(BaseTemplate, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, this.props), {
            enableHotjar: true
        }), this.buildMetaTags()), {
            children: [
                /*#__PURE__*/ _jsx(ScrollTopFabComponent, {}),
                /*#__PURE__*/ _jsx(BaseHeaderComponent, {
                    showMenu: !isInternalMobilityPage,
                    showButton: !isInternalMobilityPage,
                    trackScroll: false
                }),
                /*#__PURE__*/ _jsxs(StyledCareersComponent, {
                    className: classnames("careers-component", {
                        internal: isInternalMobilityPage
                    }),
                    children: [
                        /*#__PURE__*/ _jsxs("main", {
                            id: MAIN_ID,
                            onClick: ()=>this.resetTeamDropdownOpenState(),
                            children: [
                                this.renderInternalMobilityBannerIfNeeded(),
                                /*#__PURE__*/ _jsx(CareersHeroComponent, {
                                    isInternalMobilityPage: isInternalMobilityPage,
                                    bestPlaceToWorkProps: bestPlaceToWorkProps
                                }),
                                /*#__PURE__*/ _jsx("section", {
                                    className: "desktop-only section-search section",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "search-selectors",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "field is-grouped",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "control has-icons-right input-search",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("input", {
                                                            type: "search",
                                                            ref: (input)=>{
                                                                this.searchTermTextbox = input;
                                                            },
                                                            value: searchTermInput,
                                                            onChange: this.handleSearchTermInputChange,
                                                            onKeyPress: (event)=>{
                                                                if (event.key === "Enter") {
                                                                    this.performSearch();
                                                                }
                                                            },
                                                            className: "input",
                                                            placeholder: "Search role, team, location",
                                                            "aria-label": "Search role, team, location"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "icon is-small is-left search-icon",
                                                            children: /*#__PURE__*/ _jsx(SVGSearch, {})
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: classnames("icon", "is-small", "is-right", "clear-icon", {
                                                                "is-hidden": searchTermInput === ""
                                                            }),
                                                            onClick: this.handleClearSearchTermClick,
                                                            "aria-label": "Clear search term",
                                                            tabIndex: "0",
                                                            children: /*#__PURE__*/ _jsx(SVGClear, {})
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("button", {
                                                    className: "button blue-rnd-btn",
                                                    onClick: this.performSearch,
                                                    children: ctaText
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "search-filter-bar desktop-only",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "container",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            role: "group",
                                                            className: `filters-container ${forceDropdownsToClose ? "force-dropdowns-to-close" : ""}`,
                                                            children: [
                                                                /*#__PURE__*/ _jsx("legend", {
                                                                    children: "Filter By:"
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: `dropdown is-pill is-right is-hoverable ${isLocationDropdownOpen ? "is-active" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: `dropdown-trigger ${selectedLocation ? "has-selection" : ""}`,
                                                                            children: /*#__PURE__*/ _jsxs("button", {
                                                                                className: "button",
                                                                                "aria-haspopup": "listbox",
                                                                                "aria-controls": "dropdown-menu-locations",
                                                                                onKeyPress: (ev)=>this.handleLocationsDropdownButtonKeyPress(ev),
                                                                                onMouseEnter: ()=>this.resetTeamDropdownOpenState(),
                                                                                children: [
                                                                                    !selectedLocation ? /*#__PURE__*/ _jsx("span", {
                                                                                        children: "All Locations"
                                                                                    }) : /*#__PURE__*/ _jsxs("span", {
                                                                                        className: "is-flex",
                                                                                        children: [
                                                                                            /*#__PURE__*/ _jsx(PictureComponent, {
                                                                                                src: selectedLocation.icon,
                                                                                                isDecorative: true
                                                                                            }),
                                                                                            selectedLocation.name,
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "icon is-small",
                                                                                        children: /*#__PURE__*/ _jsx(DownArrow, {})
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "dropdown-menu",
                                                                            id: "dropdown-menu-locations",
                                                                            role: "menu",
                                                                            "aria-expanded": isLocationDropdownOpen,
                                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                                className: "dropdown-content",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "dropdown-item dropdown-title",
                                                                                        children: /*#__PURE__*/ _jsx("h2", {
                                                                                            children: "Choose your favorite location"
                                                                                        })
                                                                                    }),
                                                                                    locationsDropOptions && locationsDropOptions.map((locData)=>{
                                                                                        const locationID = getLocationID(locData.name);
                                                                                        const locationPosCount = locationID in locationsPositionCount ? locationsPositionCount[locationID] : 0;
                                                                                        return /*#__PURE__*/ _jsx("a", {
                                                                                            tabIndex: "0",
                                                                                            className: `dropdown-item ${selectedLocation && selectedLocation.id == locationID ? "is-active" : ""}`,
                                                                                            onClick: ()=>this.onLocationChange(locData),
                                                                                            onKeyPress: (event)=>this.handleDropdownOptionKeyPress(event, ()=>this.onLocationChange(locData)),
                                                                                            children: /*#__PURE__*/ _jsxs("article", {
                                                                                                className: "media",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("figure", {
                                                                                                        className: "media-left",
                                                                                                        children: /*#__PURE__*/ _jsx("p", {
                                                                                                            className: "image",
                                                                                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                                                                                src: locData.icon,
                                                                                                                isDecorative: true
                                                                                                            })
                                                                                                        })
                                                                                                    }),
                                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                                        className: "media-content",
                                                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                                                            className: "content",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ _jsx("strong", {
                                                                                                                    children: locData.name
                                                                                                                }),
                                                                                                                locationPosCount,
                                                                                                                " positions",
                                                                                                                /*#__PURE__*/ _jsx("br", {}),
                                                                                                                locData.order == 1 ? "Headquarters" : ""
                                                                                                            ]
                                                                                                        })
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        }, locData.name);
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: `dropdown is-pill is-columns-variation is-right is-hoverable ${isTeamsDropdownOpen ? "is-active" : ""} ${departmentsDropOptions.length < 4 ? "is-narrow" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: `dropdown-trigger ${selectedDept ? "has-selection" : ""}`,
                                                                            children: /*#__PURE__*/ _jsxs("button", {
                                                                                className: "button",
                                                                                "aria-haspopup": "listbox",
                                                                                "aria-controls": "dropdown-menu-teams",
                                                                                onKeyPress: (ev)=>this.handleTeamsDropdownButtonKeyPress(ev),
                                                                                children: [
                                                                                    !selectedDept ? /*#__PURE__*/ _jsx("span", {
                                                                                        children: "All Teams"
                                                                                    }) : /*#__PURE__*/ _jsxs("span", {
                                                                                        children: [
                                                                                            selectedDept.name,
                                                                                            " "
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "icon is-small",
                                                                                        children: /*#__PURE__*/ _jsx(DownArrow, {})
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "dropdown-menu",
                                                                            id: "dropdown-menu-teams",
                                                                            role: "menu",
                                                                            "aria-expanded": isTeamsDropdownOpen,
                                                                            children: /*#__PURE__*/ _jsxs("div", {
                                                                                className: "dropdown-content",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "dropdown-item dropdown-title",
                                                                                        children: /*#__PURE__*/ _jsx("h2", {
                                                                                            children: "Choose your dream team"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "columns is-multiline is-gapless",
                                                                                        children: departmentsDropOptions && departmentsDropOptions.map((deptData)=>/*#__PURE__*/ _jsx("div", {
                                                                                                className: "column is-half",
                                                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                                                    tabIndex: "0",
                                                                                                    className: `dropdown-item ${selectedDept && selectedDept.id == deptData.id ? "is-active" : ""}`,
                                                                                                    onClick: (e)=>this.onDeptChange(deptData),
                                                                                                    onKeyPress: (event)=>this.handleDropdownOptionKeyPress(event, ()=>this.onDeptChange(deptData)),
                                                                                                    children: /*#__PURE__*/ _jsxs("article", {
                                                                                                        className: "media",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ _jsx("figure", {
                                                                                                                className: "media-left",
                                                                                                                children: /*#__PURE__*/ _jsx("span", {
                                                                                                                    className: "colored-ribbon",
                                                                                                                    style: {
                                                                                                                        background: deptData.color
                                                                                                                    }
                                                                                                                })
                                                                                                            }),
                                                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                                                className: "media-content",
                                                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                                                    className: "content",
                                                                                                                    children: /*#__PURE__*/ _jsxs("p", {
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ _jsx("strong", {
                                                                                                                                children: deptData.name
                                                                                                                            }),
                                                                                                                            deptData.shortDesc
                                                                                                                        ]
                                                                                                                    })
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            }, deptData.name))
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mobile-only section-mobile-search-container",
                                    children: /*#__PURE__*/ _jsxs("section", {
                                        className: "section section-mobile-search",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "field has-addons mobile-search-input-wrapper has-mobile-search-width",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "control has-icons-right input-search",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("form", {
                                                                action: "",
                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                    type: "search",
                                                                    value: searchTermInput,
                                                                    onChange: this.handleSearchTermInputChangeForMobile,
                                                                    onKeyPress: (event)=>{
                                                                        if (event.key === "Enter") {
                                                                            this.performSearch();
                                                                            // hide keyboard on mobile
                                                                            event.preventDefault();
                                                                            if (document.activeElement) document.activeElement.blur();
                                                                            return false;
                                                                        }
                                                                    },
                                                                    className: "input",
                                                                    placeholder: "Search role, team, location",
                                                                    "aria-label": "Search role, team, location"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "icon is-small is-right",
                                                                children: /*#__PURE__*/ _jsx(SVGSearchAlt, {})
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: `control pulldown-trigger-wrapper ${selectedDept || selectedLocation ? "has-active-selection" : ""}`,
                                                        children: /*#__PURE__*/ _jsxs("a", {
                                                            className: "is-static pulldown-trigger",
                                                            onClick: this.handleMobileSideMenuToggle,
                                                            children: [
                                                                /*#__PURE__*/ _jsx(SVGFilterOff, {
                                                                    className: "filter-off"
                                                                }),
                                                                /*#__PURE__*/ _jsx(SVGFilterOn, {
                                                                    className: "filter-on"
                                                                }),
                                                                /*#__PURE__*/ _jsx(SVGFilterOnCircle, {
                                                                    className: "filter-on circ"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("p", {
                                                className: "position-counts",
                                                children: [
                                                    /*#__PURE__*/ _jsx("strong", {
                                                        children: filteredPositions ? filteredPositions.length : ""
                                                    }),
                                                    " jobs in",
                                                    /*#__PURE__*/ _jsxs("strong", {
                                                        children: [
                                                            " ",
                                                            this.countPositionLocations(filteredPositions)
                                                        ]
                                                    }),
                                                    " locations in",
                                                    /*#__PURE__*/ _jsxs("strong", {
                                                        children: [
                                                            " ",
                                                            this.countPositionTeams(filteredPositions)
                                                        ]
                                                    }),
                                                    " teams."
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    id: "mobile-search-sidemenu",
                                    role: "menu",
                                    className: `mobile-only ${isMobileSideMenuOpen ? "is-active" : ""}`,
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "relative-container",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "close-btn-container",
                                                onClick: this.handleMobileSideMenuToggle,
                                                children: /*#__PURE__*/ _jsx(SVGCloseX, {})
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "submenu-container",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: classnames("sub-menu", {
                                                            "is-active": currentMobileSideMenu === "main"
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "title-row",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("h2", {
                                                                        className: "subtitle",
                                                                        children: "Filters"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("a", {
                                                                        className: `clear-btn ${selectedLocation || selectedDept ? "" : "is-hidden"}`,
                                                                        onClick: this.handleClearSearchClick,
                                                                        children: "Clear all"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "menu-row",
                                                                onClick: ()=>this.setMobileSideCurrentSubMenu("locations"),
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                        children: "By favorite location"
                                                                    }),
                                                                    " (",
                                                                    locationsDropOptions && locationsDropOptions.length,
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "menu-row",
                                                                onClick: ()=>this.setMobileSideCurrentSubMenu("teams"),
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                        children: "By dream team"
                                                                    }),
                                                                    " (",
                                                                    departmentsDropOptions && departmentsDropOptions.length,
                                                                    ")"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: classnames("sub-menu", {
                                                            "is-active": currentMobileSideMenu === "locations"
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "title-row",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("a", {
                                                                        className: "back-btn",
                                                                        onClick: ()=>this.setMobileSideCurrentSubMenu("main"),
                                                                        children: /*#__PURE__*/ _jsx(SVGBackArrow, {})
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("h2", {
                                                                        className: "subtitle is-left-padded",
                                                                        children: "Location"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("a", {
                                                                        className: `clear-btn ${selectedLocation ? "" : "is-hidden"}`,
                                                                        onClick: this.handleClearSearchClick,
                                                                        children: "Clear"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "menu-container",
                                                                children: [
                                                                    locationsDropOptions && locationsDropOptions.map((locData)=>{
                                                                        const locationID = getLocationID(locData.name);
                                                                        const locationPosCount = locationID in locationsPositionCount ? locationsPositionCount[locationID] : 0;
                                                                        // MOBILE VARIATION:
                                                                        return /*#__PURE__*/ _jsx("div", {
                                                                            className: `menu-row location-item ${selectedLocation && selectedLocation.id == locationID ? "is-active" : ""}`,
                                                                            onClick: ()=>this.onLocationChange(locData),
                                                                            children: /*#__PURE__*/ _jsxs("article", {
                                                                                className: "media",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("figure", {
                                                                                        className: "media-left",
                                                                                        children: /*#__PURE__*/ _jsx("p", {
                                                                                            className: `image ${locationID == "london" ? "slightly-upper" : ""} `,
                                                                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                                                                src: locData.icon,
                                                                                                isDecorative: true
                                                                                            })
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "media-content",
                                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "content",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx("strong", {
                                                                                                    children: locData.name
                                                                                                }),
                                                                                                "(",
                                                                                                locationPosCount,
                                                                                                " positions)"
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }, locData.name);
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "done-btn-container",
                                                                        children: /*#__PURE__*/ _jsx("button", {
                                                                            className: "button done-btn",
                                                                            onClick: this.handleMobileSideMenuToggle,
                                                                            children: "Done"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: classnames("sub-menu", {
                                                            "is-active": currentMobileSideMenu === "teams"
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "title-row",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("a", {
                                                                        className: "back-btn",
                                                                        onClick: ()=>this.setMobileSideCurrentSubMenu("main"),
                                                                        children: /*#__PURE__*/ _jsx(SVGBackArrow, {})
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("h2", {
                                                                        className: "subtitle is-left-padded",
                                                                        children: " Team"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("a", {
                                                                        className: `clear-btn ${selectedDept ? "" : "is-hidden"}`,
                                                                        onClick: this.handleClearSearchClick,
                                                                        children: "Clear"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "menu-container",
                                                                children: [
                                                                    departmentsDropOptions && departmentsDropOptions.map((deptData)=>{
                                                                        const deptID = deptData.id;
                                                                        const deptPosCount = deptID in teamPositionCount ? teamPositionCount[deptID] : 0;
                                                                        return /*#__PURE__*/ _jsx("div", {
                                                                            className: `menu-row team-item ${selectedDept && selectedDept.id == deptID ? "is-active" : ""}`,
                                                                            onClick: (e)=>this.onDeptChange(deptData),
                                                                            children: /*#__PURE__*/ _jsxs("article", {
                                                                                className: "media",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("figure", {
                                                                                        className: "media-left",
                                                                                        children: /*#__PURE__*/ _jsx("span", {
                                                                                            className: "colored-ribbon",
                                                                                            style: {
                                                                                                background: deptData.color
                                                                                            }
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "media-content",
                                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                                            className: "content",
                                                                                            children: /*#__PURE__*/ _jsxs("p", {
                                                                                                children: [
                                                                                                    /*#__PURE__*/ _jsx("strong", {
                                                                                                        children: deptData.name
                                                                                                    }),
                                                                                                    "(",
                                                                                                    deptPosCount,
                                                                                                    " positions)"
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }, deptData.name);
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "done-btn-container",
                                                                        children: /*#__PURE__*/ _jsx("button", {
                                                                            className: "button done-btn",
                                                                            onClick: this.handleMobileSideMenuToggle,
                                                                            children: "Done"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("section", {
                                    className: "section section-positions",
                                    children: [
                                        filteredPositions && filteredPositions.length == 0 && /*#__PURE__*/ _jsxs("div", {
                                            className: "no-search-results has-text-centered",
                                            children: [
                                                /*#__PURE__*/ _jsx(PictureComponent, {
                                                    src: "/static/img/careers/cactus.png",
                                                    isDecorative: true
                                                }),
                                                /*#__PURE__*/ _jsxs("h3", {
                                                    className: "title",
                                                    children: [
                                                        "Sorry, there’s nothing here.",
                                                        /*#__PURE__*/ _jsx("br", {}),
                                                        "Try using different keywords or filters :)"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: classnames("loader-container", {
                                                "is-hidden": !isLoaderShown
                                            }),
                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                src: "/static/img/loader/monday_loader.gif"
                                            })
                                        }),
                                        filteredPositions && filteredPositions.length > 0 && /*#__PURE__*/ _jsxs("div", {
                                            className: "container desktop-only",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: /*#__PURE__*/ _jsxs("p", {
                                                        className: "position-counts desktop-only",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("strong", {
                                                                children: filteredPositions ? filteredPositions.length : ""
                                                            }),
                                                            " jobs in",
                                                            /*#__PURE__*/ _jsxs("strong", {
                                                                children: [
                                                                    " ",
                                                                    this.countPositionLocations(filteredPositions)
                                                                ]
                                                            }),
                                                            " locations in",
                                                            /*#__PURE__*/ _jsxs("strong", {
                                                                children: [
                                                                    " ",
                                                                    this.countPositionTeams(filteredPositions)
                                                                ]
                                                            }),
                                                            " teams."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("table", {
                                                    className: "table",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("thead", {
                                                            className: "is-sr-only",
                                                            children: /*#__PURE__*/ _jsxs("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("th", {
                                                                        children: "Job Title & Description"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("th", {
                                                                        children: "Team"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("th", {
                                                                        children: "Location"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("tbody", {
                                                            children: filteredPositions && this.getPositionsPage(currentPageNum).map((pos, index)=>{
                                                                const deptInfo = getDeptInfo(pos);
                                                                const locationInfo = getLocationInfoFromPosition(pos);
                                                                return /*#__PURE__*/ _jsxs("tr", {
                                                                    className: index >= COLLPASED_TABLE_RESULTS_LIMIT && !isShowMore ? "is-hidden" : "",
                                                                    tabIndex: "0",
                                                                    onKeyPress: generateOnKeyDownHandler(this.onRowKeyPress, pos, selectedLocation, selectedDept),
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("td", {
                                                                            className: "pos-name",
                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                href: this.getPositionLink(pos),
                                                                                onClick: ()=>this.onPositionLinkClicked(pos.name, selectedLocation, selectedDept),
                                                                                tabIndex: "-1",
                                                                                children: /*#__PURE__*/ _jsx("article", {
                                                                                    className: "media",
                                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                                        className: "media-content",
                                                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "content",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx("span", {
                                                                                                    className: "position-name",
                                                                                                    children: pos.name
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx("small", {
                                                                                                    children: this.getPositionShortSanitizedText(pos)
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("td", {
                                                                            className: "iconwithlabel pos-dept",
                                                                            children: deptInfo != null && /*#__PURE__*/ _jsx("span", {
                                                                                children: deptInfo.name
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("td", {
                                                                            className: "iconwithlabel",
                                                                            children: locationInfo != null && /*#__PURE__*/ _jsxs("span", {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                                                            src: locationInfo.icon,
                                                                                            isDecorative: true
                                                                                        })
                                                                                    }),
                                                                                    locationInfo.name
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }, pos.uid);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mobile-results mobile-only",
                                            children: filteredPositions && this.getPositionsPage(currentPageNum).map((pos, index)=>{
                                                const deptInfo = getDeptInfo(pos);
                                                const locationInfo = getLocationInfoFromPosition(pos);
                                                return /*#__PURE__*/ _jsx("div", {
                                                    className: index > COLLPASED_TABLE_RESULTS_LIMIT_MOBILE && !isShowMore ? "is-hidden" : "result",
                                                    children: /*#__PURE__*/ _jsxs("a", {
                                                        href: this.getPositionLink(pos),
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "position-name",
                                                                children: pos.name
                                                            }),
                                                            /*#__PURE__*/ _jsx("small", {
                                                                children: this.getPositionShortSanitizedText(pos)
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "bottom-row",
                                                                children: [
                                                                    deptInfo != null && /*#__PURE__*/ _jsx("div", {
                                                                        className: "colored-pill",
                                                                        style: {
                                                                            backgroundColor: deptInfo.color
                                                                        },
                                                                        children: deptInfo.name
                                                                    }),
                                                                    locationInfo != null && /*#__PURE__*/ _jsx("div", {
                                                                        className: "colored-pill location-pill",
                                                                        children: locationInfo.name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, pos.uid);
                                            })
                                        }),
                                        filteredPositions && filteredPositions.length > COLLPASED_TABLE_RESULTS_LIMIT && /*#__PURE__*/ _jsxs("div", {
                                            className: "show-more-less-container has-text-centered",
                                            children: [
                                                !isShowMore && /*#__PURE__*/ _jsxs("a", {
                                                    role: "button",
                                                    tabIndex: "0",
                                                    className: " show-more-less",
                                                    onClick: this.handleShowMoreClick,
                                                    children: [
                                                        "Show more openings ",
                                                        /*#__PURE__*/ _jsx(DownPointedArrow, {})
                                                    ]
                                                }),
                                                isShowMore && numOfPages > 1 && /*#__PURE__*/ _jsx("nav", {
                                                    className: "pagination is-centered",
                                                    role: "navigation",
                                                    "aria-label": "pagination",
                                                    children: /*#__PURE__*/ _jsxs("ul", {
                                                        className: "pagination-list",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    className: classnames("pagination-link", "directional-progress-link", "link-prev", {
                                                                        "is-disabled": currentPageNum == 1
                                                                    }),
                                                                    title: "Previous",
                                                                    onClick: ()=>this.setPageNumber(currentPageNum - 1),
                                                                    children: /*#__PURE__*/ _jsx(SVGCaret, {})
                                                                })
                                                            }),
                                                            paginationArray && paginationArray.map((pageNum)=>/*#__PURE__*/ _jsx("li", {
                                                                    children: pageNum === "..." ? /*#__PURE__*/ _jsx("span", {
                                                                        className: "pagination-ellipsis",
                                                                        children: "…"
                                                                    }) : /*#__PURE__*/ _jsx("a", {
                                                                        onClick: ()=>this.setPageNumber(pageNum),
                                                                        className: classnames("pagination-link", {
                                                                            "is-current": currentPageNum == pageNum
                                                                        }),
                                                                        "aria-label": `Page ${pageNum}`,
                                                                        children: pageNum
                                                                    })
                                                                })),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx("a", {
                                                                    className: classnames("pagination-link", "directional-progress-link", {
                                                                        "is-disabled": currentPageNum == numOfPages
                                                                    }),
                                                                    title: "Next",
                                                                    onClick: ()=>this.setPageNumber(currentPageNum + 1),
                                                                    children: /*#__PURE__*/ _jsx(SVGCaret, {})
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !isInternalMobilityPage && this.renderExternalCareersBottomFolds()
                            ]
                        }),
                        isInternalMobilityPage && this.renderInternalCareersBottomFolds(),
                        /*#__PURE__*/ _jsx("section", {
                            className: "section container section-footer desktop-only",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "#search-positions",
                                className: "careers-rnd-btn",
                                onClick: ()=>this.onBottomCTAClick(),
                                children: "Search open positions"
                            })
                        })
                    ]
                }),
                !isInternalMobilityPage && /*#__PURE__*/ _jsx(LongFooterComponent, {})
            ]
        }));
    }
    constructor(props){
        super(props);
        _define_property(this, "renderBestWorkPlace", ()=>{
            return /*#__PURE__*/ _jsx("section", {
                className: "section section-best-work-place-mobile",
                children: /*#__PURE__*/ _jsx(TextAndProof, _object_spread({}, bestPlaceToWorkProps))
            });
        });
        _define_property(this, "renderTestimonialsSection", ()=>{
            const { testimonials } = this.state;
            return /*#__PURE__*/ _jsx("section", {
                className: "section section-testimonials",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ _jsxs("h3", {
                            className: "title has-text-centered",
                            children: [
                                "What our team ",
                                /*#__PURE__*/ _jsx("strong", {
                                    children: "loves "
                                }),
                                "about monday.com"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Slider, {
                            autoplaySpeed: 8000,
                            autoplay: true,
                            infinite: true,
                            draggable: false,
                            dots: true,
                            arrows: true,
                            speed: 500,
                            pauseOnFocus: false,
                            pauseOnHover: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: false,
                            customPaging: (i)=>/*#__PURE__*/ _jsx("button", {
                                    "aria-label": `Page ${i + 1}`,
                                    type: "button",
                                    children: i + 1
                                }),
                            children: testimonials && testimonials.map((quote, idx)=>{
                                // suppoting **bold** text - middle token will have bold text
                                const splitTexts = quote.text.split("**");
                                // just in case that no '**' exists in string:
                                if (splitTexts.length < 3) {
                                    splitTexts[1] = "";
                                    splitTexts[2] = "";
                                }
                                return /*#__PURE__*/ _jsx("div", {
                                    className: "quote-slide",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "quote-container",
                                        children: [
                                            /*#__PURE__*/ _jsx(SVGQuote, {
                                                className: "quote-icon",
                                                style: {
                                                    fill: quote.color
                                                }
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "quote-inner",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("blockquote", {
                                                        children: [
                                                            splitTexts[0],
                                                            /*#__PURE__*/ _jsx("strong", {
                                                                children: splitTexts[1]
                                                            }),
                                                            splitTexts[2]
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "quotee-details",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "quotee-name",
                                                                children: quote.name
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "quotee-title",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "mobile-only pipe",
                                                                        children: " | "
                                                                    }),
                                                                    quote.title,
                                                                    " | ",
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "quotee-dept",
                                                                        children: quote.dept
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("figure", {
                                                        className: "image quotee-img",
                                                        style: {
                                                            background: quote.color
                                                        },
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "quotee-img-container",
                                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                                src: quote.imageUrl,
                                                                isDecorative: true
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, quote.name);
                            })
                        })
                    ]
                })
            });
        });
        _define_property(this, "renderMondayValuesSection", ()=>{
            return /*#__PURE__*/ _jsxs("section", {
                className: "section section-tiles",
                children: [
                    /*#__PURE__*/ _jsxs("h3", {
                        className: "title has-text-centered",
                        children: [
                            "What monday.com is ",
                            /*#__PURE__*/ _jsx("strong", {
                                children: "all about"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "tiles-container container desktop-only",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "tile is-ancestor is-gapless",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            tabIndex: "0",
                                            className: "tile is-child has-background-yellow hover-effect",
                                            style: {
                                                color: "#383B45"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: "Transparency"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Transparency creates a culture of inclusion and alignment, ensuring everyone is on the same page while striving for success together."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tile is-6 is-parent",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "tile is-child",
                                            onMouseEnter: ()=>this.trackEventImageTileHover(),
                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                className: "tile-img",
                                                src: "/static/img/careers/tiles/wide0.png",
                                                isDecorative: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "tile is-child has-background-red hover-effect",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: "Impact"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Impact is the engine behind any project of ours. We strive to do good for our customers and community, to create an environment where meaningful changes can be made."
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "tile is-ancestor is-gapless",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "tile is-parent is-vertical",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tile is-child",
                                                onMouseEnter: ()=>this.trackEventImageTileHover(),
                                                children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ0.png",
                                                    isDecorative: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tile is-child",
                                                onMouseEnter: ()=>this.trackEventImageTileHover(),
                                                children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ1.png",
                                                    isDecorative: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tile is-parent is-vertical",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "tile is-child has-background-blue hover-effect",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "is-rotated-text",
                                                        children: "Data Driven"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Expectations will be demystified through clear goals and data-driven decision making. You'll know your role and be given the tools to empower yourself and others - all through data."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "tile is-parent is-vertical",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "tile is-child has-background-green hover-effect",
                                                tabIndex: "0",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "tile-content front has-brand-value",
                                                        children: "Accountability"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "tile-content back has-text",
                                                        children: "We hold ourselves accountable for everything we do, both successes and failures. We celebrate our collective achievements, yet embrace individual responsibility while doing so."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tile is-child",
                                                onMouseEnter: ()=>this.trackEventImageTileHover(),
                                                children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ5.png",
                                                    isDecorative: true
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "tile is-parent is-vertical",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tile is-child",
                                                onMouseEnter: ()=>this.trackEventImageTileHover(),
                                                children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ4.png",
                                                    isDecorative: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "tile is-child",
                                                onMouseEnter: ()=>this.trackEventImageTileHover(),
                                                children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                    className: "tile-img",
                                                    src: "/static/img/careers/tiles/squ2.png",
                                                    isDecorative: true
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "tile is-ancestor is-gapless",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "tile is-child has-background-green hover-effect",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content front has-brand-value",
                                                    children: "Ownership"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "tile-content back has-text",
                                                    children: "Ownership means we take control of our projects from start to finish. We’re empowered to make independent decisions while knowing our team is right behind us at all times."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tile is-3 is-parent",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "tile is-child",
                                            onMouseEnter: ()=>this.trackEventImageTileHover(),
                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                className: "tile-img",
                                                src: "/static/img/careers/tiles/squ3.png",
                                                isDecorative: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "tile is-6 is-parent",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "tile is-child",
                                            onMouseEnter: ()=>this.trackEventImageTileHover(),
                                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                className: "tile-img",
                                                src: "/static/img/careers/tiles/wide1.png",
                                                isDecorative: true
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "values-slider mobile-only",
                        children: /*#__PURE__*/ _jsxs(Slider, {
                            autoplaySpeed: 8000,
                            autoplay: true,
                            infinite: true,
                            draggable: false,
                            dots: true,
                            arrows: false,
                            speed: 1500,
                            pauseOnFocus: false,
                            pauseOnHover: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            adaptiveHeight: true,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "value-slide container has-background-yellow",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "value-title",
                                            children: "Transparency"
                                        }),
                                        /*#__PURE__*/ _jsx(PictureComponent, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide0.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "value-slide container has-background-green",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "value-title ",
                                            children: "Accountability"
                                        }),
                                        /*#__PURE__*/ _jsx(PictureComponent, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide3.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "value-slide container",
                                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                                        className: "value-image full-height",
                                        src: "/static/img/careers/tiles/squ1.png",
                                        isDecorative: true
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "value-slide container has-background-red",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "value-title ",
                                            children: "Impact"
                                        }),
                                        /*#__PURE__*/ _jsx(PictureComponent, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide4.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "value-slide container has-background-green",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "value-title ",
                                            children: "Ownership"
                                        }),
                                        /*#__PURE__*/ _jsx(PictureComponent, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide5.png",
                                            isDecorative: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "value-slide container has-background-blue",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "value-title ",
                                            children: "Data Driven"
                                        }),
                                        /*#__PURE__*/ _jsx(PictureComponent, {
                                            className: "value-image",
                                            src: "/static/img/careers/tiles/wide1.png",
                                            isDecorative: true
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            });
        });
        _define_property(this, "renderInTheNewsSection", ()=>{
            return /*#__PURE__*/ _jsxs("section", {
                className: "section section-news",
                children: [
                    /*#__PURE__*/ _jsxs("h3", {
                        className: "title has-text-centered",
                        children: [
                            "monday.com ",
                            /*#__PURE__*/ _jsx("strong", {
                                children: "in the news"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "container",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "columns",
                            children: careersConfig.news.map((newsItem, index)=>/*#__PURE__*/ _jsx("div", {
                                    className: "column is-4",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        onClick: ()=>this.onNewsItemClicked(newsItem.link),
                                        target: "_blank",
                                        href: newsItem.link,
                                        rel: "noreferrer",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card card-news",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "card-image",
                                                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                                                        className: "image is-1by1",
                                                        src: newsItem.imageUrl,
                                                        alt: newsItem.imageAlt
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "card-content",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: newsItem.title
                                                        }),
                                                        /*#__PURE__*/ _jsx("footer", {
                                                            className: "card-footer",
                                                            children: /*#__PURE__*/ _jsxs("p", {
                                                                children: [
                                                                    "Source: ",
                                                                    newsItem.source
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, index))
                        })
                    })
                ]
            });
        });
        _define_property(this, "renderEqualOpportunitySection", ()=>{
            const bottomFoldText = careersConfig.bottomFoldText;
            return /*#__PURE__*/ _jsx("section", {
                className: "section section-equality",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "diversity-paragraph",
                    dangerouslySetInnerHTML: {
                        __html: bottomFoldText
                    }
                })
            });
        });
        _define_property(this, "buildMetaTags", ()=>{
            const isInternalMobilityPage = this.isInternalMobilityPage();
            return _object_spread_props(_object_spread({}, META_OVERRIDE), {
                title: isInternalMobilityPage ? INTERNAL_JOBS_TITLE : TITLE,
                description: isInternalMobilityPage ? INTERNAL_JOBS_DESCRIPTION : DESCRIPTION,
                noIndex: isInternalMobilityPage,
                noFollow: isInternalMobilityPage
            });
        });
        _define_property(this, "onRowKeyPress", (event, pos, selectedLocation, selectedDept)=>{
            this.onPositionLinkClicked(pos.name, selectedLocation, selectedDept);
            window.location.href = this.getPositionLink(pos);
        });
        _define_property(this, "isInternalMobilityPage", ()=>{
            const { positionsType } = this.props;
            return positionsType === POSITION_TYPE_INTERNAL;
        });
        _define_property(this, "getPositionLink", (position)=>{
            const careersRootUrl = this.isInternalMobilityPage() ? INTERNAL_CAREERS_ROOT_URL : CAREERS_ROOT_URL;
            return `${careersRootUrl}${position.uid}`;
        });
        _define_property(this, "getCtaText", ()=>{
            if (this.isInternalMobilityPage()) {
                return "Explore your growth";
            }
            return "Find your role";
        });
        _define_property(this, "renderExternalCareersBottomFolds", ()=>{
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    this.renderBestWorkPlace(),
                    this.renderTestimonialsSection(),
                    this.renderMondayValuesSection(),
                    this.renderInTheNewsSection(),
                    this.renderEqualOpportunitySection()
                ]
            });
        });
        _define_property(this, "renderInternalMobilityBannerIfNeeded", ()=>{
            if (!this.isInternalMobilityPage()) return null;
            return /*#__PURE__*/ _jsx(PlainBannerComponent, {
                theme: WORKOS_IRIS_THEME_ID,
                withCloseIcon: false,
                bannerText: "Happy to see you here! Please read the guidelines before applying 👉  ",
                bannerLinkData: {
                    text: "Read me",
                    src: "https://app.getguru.com/card/izRaBrpT/Internal-mobility-process"
                }
            });
        });
        _define_property(this, "renderInternalCareersBottomFolds", ()=>{
            const bottomFoldText = careersConfig.bottomFoldText;
            const videoDesktopHeight = "470px";
            const videoDesktopWidth = "840px";
            const videoId = "EKlJ0hnD2ME";
            const { isMobileOrTabletBrowser } = this.props;
            const videoWidth = isMobileOrTabletBrowser ? "100%" : videoDesktopWidth;
            const videoHeight = isMobileOrTabletBrowser ? "unset" : videoDesktopHeight;
            return /*#__PURE__*/ _jsxs("div", {
                className: "internal-careers-bottom-folds",
                children: [
                    /*#__PURE__*/ _jsxs("h3", {
                        className: "title has-text-centered internal-title",
                        children: [
                            "Internal mobility at monday.com: ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "successes, stories, and tips!"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "internal-careers-video",
                        children: /*#__PURE__*/ _jsx(YoutubeVideoComponent, {
                            videoId: videoId,
                            muted: false,
                            volume: 100,
                            opts: {
                                width: videoWidth,
                                height: videoHeight
                            }
                        })
                    }),
                    this.renderEqualOpportunitySection()
                ]
            });
        });
        this.handleSearchTermInputChange = this.handleSearchTermInputChange.bind(this);
        this.handleSearchTermInputChangeForMobile = this.handleSearchTermInputChangeForMobile.bind(this);
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
        this.handleClearSearchClick = this.handleClearSearchClick.bind(this);
        this.handleClearSearchTermClick = this.handleClearSearchTermClick.bind(this);
        this.handleMobileSideMenuToggle = this.handleMobileSideMenuToggle.bind(this);
        this.performSearch = this.performSearch.bind(this);
        this.debounceTimeout = undefined;
        this.state = {
            testimonials: null,
            filteredPositions: null,
            // current user input:
            searchTermInput: "",
            // current search term: (after submitting search)
            searchTerm: "",
            searchTermIsDirty: false,
            selectedLocation: null,
            selectedDept: null,
            isShowMore: false,
            positionsTableData: null,
            locationsPositionCount: {},
            teamPositionCount: {},
            forceDropdownsToClose: false,
            isTeamsDropdownOpen: false,
            isLocationDropdownOpen: false,
            isMobileSideMenuOpen: false,
            currentMobileSideMenu: "main",
            departmentsDropOptions: [],
            currentPageNum: 1,
            isLoaderShown: false
        };
    }
}
export { CareersComponent as default };
